import { helpers } from '../helpers.js';

var accordion = {

    selectors: {
        element: '[data-accordion]',
        trigger: '[data-accordion-trigger]',
        content: '[data-accordion-content]',
        item: '[data-accordion-item]'
    },

    init: function() {
        var self = this;

        $(self.selectors.element).each(function() {
            var $accordion = $(this);
            var $triggers = $accordion.find(self.selectors.trigger);
            var $items = $accordion.find(self.selectors.item);
            var $contents = $accordion.find(self.selectors.content);

            $triggers.on('click', function(e) {
                e.preventDefault();
                
                var $trigger = $(this);
                var targetId = $trigger.attr('data-accordion-trigger');
                var $targetItem = $accordion.find('[data-accordion-item="' + targetId + '"]');
                var $targetContent = $accordion.find('[data-accordion-content="' + targetId + '"]');
                var $icon = $trigger.find('.branches__accordion__icon');
                
                var isOpen = $targetItem.hasClass('branches__accordion__item--active');
                
                if (isOpen) {
                    $targetItem.removeClass('branches__accordion__item--active');
                    $targetContent.removeClass('branches__accordion__content--open');
                } else {
                    $items.removeClass('branches__accordion__item--active');
                    $contents.removeClass('branches__accordion__content--open');
                    
                    $targetItem.addClass('branches__accordion__item--active');
                    $targetContent.addClass('branches__accordion__content--open');
                }
            });
        });
    }
};

export { accordion };